// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-gtKC6","text":"text-15EwQ","button":"button-G_y6o"};